import * as Yup from "yup";
import { MaxDeltagerWarningBox } from "../../../components/MaxDeltagerWarningBox";

export const linjeKursistForm = (
  antal: number | undefined,
  fmulinjeId: string,
  fmulinjeKursistId?: string,
): FormConfig<ILinjeKursistDTO> => {
  const get = `fmulinje/${fmulinjeId}/kursister/${fmulinjeKursistId}`;
  const postQuery = `fmulinje/${fmulinjeId}/kursister`;
  return {
    get,
    title: "kursist",
    form: [
      {
        component: "custom",
        id: "warning",
        customComponent: ({ formik }) => {
          return (
            <MaxDeltagerWarningBox formik={formik} antal={antal} type="linje" />
          );
        },
      },
      {
        component: "person",
        id: "personId",
        label: "Kursist",
        placeholder: "Søg og vælg kursist ...",
        isRequired: true,
      },
      {
        component: "kode-select",
        id: "overnatning",
        initialValue: "MellemKursusdagene",
        kodeListeType: "OvernatningstypeKode",
        label: "Overnatning",
        placeholder: "Vælg overnatningstype",
        isRequired: true,
      },
    ],
    validationSchema: Yup.object({
      personId: Yup.string().required("Kursist skal være valgt"),
      overnatning: Yup.string().required("Overnatning skal være valgt"),
    }),
    post: (body) => {
      return {
        query: postQuery,
        body,
      };
    },
    postReinit: true,
  };
};

export interface ILinjeKursistDTO {
  warning: boolean;
  personId: string;
  overnatning: string;
}
